var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngagementMeterHand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #00a017;\n      }\n    "))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.707107, -0.707106, 0.707106, -0.707107, -619.257446, -537.941833)",
    style: {
      transformOrigin: "1018.42px 634.978px"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1243.34,390.02l-313.08,401.6c-1.53,24.2-1.85,44.58-18.31,64.25-46.65,55.76-135.04,22.7-134.55-49.59.33-48.32,39.09-73.28,83.25-77.13l362.15-358.39c6.31-2.78,21.65,14.06,20.54,19.26Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagementMeterHand);
export default __webpack_public_path__ + "static/media/Engagement Meter Hand.bf26444f69ad63868c50c82f4b07dbee.svg";
export { ForwardRef as ReactComponent };